@if (assetFirmwareInfo === undefined) {
	<div class="loading-status">
		<div class="logo-spin"></div>
		Loading...
	</div>
}
@if (assetFirmwareInfo === null && errormessage) {
	<div class="loading-status">
		Unable to retrieve available firmware.<br />
		{{ errormessage }}
	</div>
}
@if (assetFirmwareInfo) {
	<div>
		<div class="section-title">Outgoing OBCU command</div>
		<div class="mb-3 row">
			<label class="col-md-4">Pending command.xml:</label>
			@if (assetFirmwareInfo.commandFile) {
				<div class="col-md-6 text-success">Present</div>
			}
			@if (assetFirmwareInfo.commandFile) {
				<div class="col-md-2">
					<app-action-button [action]="CancelCommand" [context]="this" btnClass="icon red" confirm="Are you sure? This will rename command.xml to command.cancelled.date.xml"
						processing="..."><i class="icon-trash"></i></app-action-button>
				</div>
			}
			@if (!assetFirmwareInfo.commandFile) {
				<div class="col-md-8">None</div>
			}
		</div>
		<div class="section-title">Schedule a command</div>
		@if (assetFirmwareInfo && assetFirmwareInfo.firmware) {
			<div class="mb-3 row">
				<label class="col-md-4">Hardware Target:@if (assetFirmwareInfo.currentTarget) {
					<span><br />(Last known: {{assetFirmwareInfo.currentTargetName}})</span>
				}</label>
				<div class="col-md-8">
					<select [(ngModel)]="selectedFirmware" class="form-control">
						@for (firmware of assetFirmwareInfo.firmware; track firmware) {
							<option [ngValue]="firmware">{{firmware.name}}</option>
						}
					</select>
				</div>
			</div>
		}
		@if (selectedFirmware) {
			<div>
				<div class="row text-white">
					<div class="col-md-2 text-center">Include</div>
					<label class="col-md-2">Target</label>
					<div class="col-md-6">Version</div>
				</div>
				@if (selectedFirmware.control) {
					<div class="row">
						<div class="col-md-2 text-center">
							<input [(ngModel)]="selectFwControl" (ngModelChange)="checkControl()" [disabled]="!enableControl" type="checkbox">
						</div>
						<label class="col-md-2">Control</label>
						<div class="col-md-6">{{selectedFirmware.control}}</div>
					</div>
				}
				@if (selectedFirmware.webpage) {
					<div class="row">
						<div class="col-md-2 text-center">
							<input [(ngModel)]="selectFwWebpage" (ngModelChange)="checkControl()" [disabled]="!enableControl" type="checkbox">
						</div>
						<label class="col-md-2">Webpage</label>
						<div class="col-md-6">{{selectedFirmware.webpage}}</div>
					</div>
				}
				@if (selectedFirmware.regime) {
					<div class="row">
						<div class="col-md-2 text-center">
							<input [(ngModel)]="selectFwRegime" (ngModelChange)="checkRegime()" [disabled]="!enableRegime" type="checkbox">
						</div>
						<label class="col-md-2">Regime</label>
						<div class="col-md-6">{{selectedFirmware.regime}}</div>
					</div>
				}
				@if (selectedFirmware.state) {
					<div class="row">
						<div class="col-md-2 text-center">
							<input [(ngModel)]="selectFwState" (ngModelChange)="checkRegime()" [disabled]="!enableRegime" type="checkbox">
						</div>
						<label class="col-md-2">State</label>
						<div class="col-md-6">{{selectedFirmware.state}}</div>
					</div>
				}
			</div>
		}
		<div class="row">
			<div class="col-md-2 text-center">
				<input [(ngModel)]="selectDescribe" (ngModelChange)="checkDescribe()" [disabled]="!enableDescribe" type="checkbox">
			</div>
			<label class="col-md-2">Describe</label>
			<div class="col-md-6">Perform a describe command</div>
		</div>
		<div class="row">
			<div class="col-md-2 text-center">
				<input [(ngModel)]="selectIdent" (ngModelChange)="checkIdent()" [disabled]="!enableIdent" type="checkbox">
			</div>
			<label class="col-md-2">Update ident</label>
			<div class="col-md-6">Set the obcu ident to Fleet: <b>{{asset.fleet_name}}</b> Asset: <b>{{asset.asset_name}}</b> Asset SN: <b>{{asset.asset_serial_number}}</b></div>
		</div>
		<div class="row">
			<div class="col-md-4 mt-3">
				<app-action-button [action]="CreateCommand" [context]="this" processing="Uploading..." complete="Command created">Create command.xml</app-action-button>
			</div>
		</div>
		<div class="row">
			<div class="col-md-8 mt-3">
				<app-action-button [action]="CreateZip" [context]="this" processing="Uploading..." complete="Zip created">Create foresightlite_command.zip</app-action-button>
			</div>
		</div>
		<div class="row">
			<div class="col-md-8 mt-5">
				<app-action-button [action]="UploadConfig" file [context]="this" processing="Uploading..." complete="Command created">Upload HUMS_OBCU_Configuration and create
					command.xml</app-action-button>
			</div>
		</div>
	</div>
	}